module.exports = __webpack_public_path__ + "static/media/transactions-empty@3x.d592abc5.png";